export default "__VITE_ASSET__f51cdc6c__"